import styled from 'styled-components';

export const StyledBlogDetailsWrappper = styled.section`
    .footer {
    }
`;